import React from "react";
import { useSelector } from "react-redux";

import {
  Modal,
  Typography,
  Paper,
  CircularProgress,
  LinearProgress
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles(theme => ({
  paper: {
    boxShadow: theme.shadows[5],
    padding: "32px 50px",
    outline: 0
  },

  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  title: {
    marginBottom: "30px"
  },

  step: {
    marginTop: "8px",
    marginBottom: "8px"
  },

  stepIncomplete: {
    width: "16px",
    height: "16px",
    backgroundColor: "#dedede",
    float: "left",
    marginTop: "3px",
    marginRight: "10px",
    borderRadius: "8px"
  },

  stepInProgress: {
    width: "16px",
    height: "16px",
    float: "left",
    marginTop: "3px",
    marginRight: "10px"
  },

  stepComplete: {
    width: "20px",
    height: "20px",
    color: "#00bc34",
    float: "left",
    marginTop: "1px",
    marginRight: "6px"
  },

  linearProgress: {
    color: "#00bc34",
    marginTop: "5px",
    marginBottom: "10px",
    marginLeft: "26px"
  }
}));

export default props => {
  const classes = useStyles();

  let loader = useSelector(state => state.global.smartLoader);

  return (
    <>
      <Modal className={classes.modal} open={loader.loading}>
        <Paper className={classes.paper}>
          <Typography variant="h5" className={classes.title}>
            { loader.title }
          </Typography>
          {
            loader.steps.map((step, index) => <Step key={index} step={step} />)
          }
        </Paper>
      </Modal>
      { props.children }
    </>
  );
};

const Step = ({ step }) => {
  const classes = useStyles();

  let indicator = null;

  if (step.inProgress) {
    indicator = <CircularProgress size={16} className={classes.stepInProgress} />
  } else if (step.completed) {
     indicator = <CheckCircleIcon className={classes.stepComplete} />
  } else {
    indicator = <div className={classes.stepIncomplete}></div>;
  }

  let linearProgressIndicator = null;

  if (step.inProgress && step.hasOwnProperty('progress')) {
    linearProgressIndicator = (
      <LinearProgress
        className={classes.linearProgress}
        variant="determinate"
        value={step.progress} />
    )
  }

  return (
    <div className={classes.step}>
      {indicator}

      <Typography>
        { step.title }
      </Typography>

      { linearProgressIndicator }
    </div>
  );
};
